import ServiceBase from "base/baseService"

export default class TamanhoService extends ServiceBase {

    title = "Tamanho"
    pluralTitle = "Tamanhos"
    url = '/cadastro/produto/tamanho'
    frontUrl = '/cadastro/produto/tamanho'
    frontUrlList = '/cadastro/produto/tamanholist'
    primaryKey = 'codigo_tam'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        return data
    }

    prepareToSave({ data }) {

        delete data.meta

        return data

    }

}
